import {
  MdHome,
  MdPeople,
  MdInventory,
  MdViewInAr,
  MdChat,
  MdAccountCircle,
} from "react-icons/md";

export const MENU_ADMIN = [
  {
    name: "Inicio",
    href: "/",
    icon: MdHome,
  },
  {
    name: "Gestionar Clientes",
    href: "/admin/clients",
    icon: MdPeople,
  },
  {
    name: "Gestionar Usuarios",
    href: "/admin/moderators",
    icon: MdPeople,
  },
  {
    name: "Gestionar BL",
    href: "/admin/packages",
    icon: MdInventory,
  },
  {
    name: "Cargar Contenido BL",
    href: "/admin/products",
    icon: MdViewInAr,
  },
  // {
  //   name: "Chat",
  //   href: "/chat",
  //   icon: MdChat,
  // },
  // {
  //   name: "Reporte de Recepciones",
  //   href: "/admin/receptions-report",
  //   icon: MdPeople,
  // },
  {
    name: "Mi Cuenta",
    href: "/admin/profile",
    icon: MdAccountCircle,
  },
];
